'use client';

import Link from '@lichtblick/link';
import { type TrackingData, useTracker } from '@lichtblick/tracker';
import classNames from 'classnames';
import type { FC, PropsWithChildren } from 'react';
import utilityStyles from '../../theme/utilities.module.scss';
import styles from './image-teaser.module.css';

export type LinkProps = {
  href?: string;
  isDownloadLink?: boolean;
  onClick?: () => void;
  shouldOpenInNewTab?: boolean;
  title: string;
};

type ImageTeaserProps = PropsWithChildren & {
  theme: 'subtle' | 'standard';
  className?: string;
  headline?: string;
  link: LinkProps;
  tracking?: TrackingData;
};

export const ImageTeaserLink: FC<ImageTeaserProps> = ({ theme, children, className, headline, link, tracking }) => {
  const { trackCustomEvent } = useTracker();

  const trackEvent = (trackingData?: TrackingData) => {
    trackCustomEvent(trackingData);

    if (link?.href?.includes('onelink')) {
      trackCustomEvent(
        {
          eventName: 'app_link',
          customProps: {
            link_type: 'Onelink',
          },
        },
        undefined,
        false,
      );
    }
  };

  return (
    <Link
      aria-label={headline ?? link?.title}
      className={classNames('image-teaser', utilityStyles[`theme-bg-${theme}`], styles['image-teaser'], className)}
      data-testid="image-teaser"
      download={link?.isDownloadLink}
      href={link?.href ?? '#'}
      onClick={() => {
        link?.onClick?.();
        trackEvent(tracking);
      }}
      target={link?.shouldOpenInNewTab ? '_blank' : undefined}
    >
      {children}
    </Link>
  );
};
